import React, { Component } from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Location } from 'history'
import { connect } from 'react-redux'
import Navbar from '../Components/Navbar/Navbar'
import Sidebar from '../Components/Sidebar'
import { Route as RouteType } from '../Types/Route'
import styles from '../Assets/Styles/Views/Layout.module.css'
import BottomBar from '../Components/BottomBar'
import Checkout from '../Components/Book/Checkout'
import FullLoading from '../Components/FullLoading'

type Props = {
  project: any
}

type State = {
  collapsed: boolean
}

class Layout extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      collapsed: true
    }
  }

  toggleCollapse = (): void => {
    this.setState((prevState: State) => ({ collapsed: !prevState.collapsed }))
  }

  closeSidebar = (): void => {
    if (!this.state.collapsed) {
      this.setState({ collapsed: true })
    }
  }

  createRoutes = (routes: RouteType[] = []): React.ReactElement => (
    <Switch>
      {routes.map(({ component: RComponent, ...r }: RouteType) => (
        <Route
          key={r.name}
          render={(props: RouteComponentProps<any>) => (
            <RComponent {...props} {...r} />
          )}
          path={r.path}
        />
      ))}
    </Switch>
  )

  render (): React.ReactElement {
    const { routes, location, project } = this.props
    const { collapsed } = this.state
    return (
      <div className={styles.container}>
        <Sidebar
          routes={routes as RouteType[]}
          collapsed={collapsed}
          location={location as Location}
        />
        <div
          className={`${styles.primarySection} ${
            collapsed ? '' : styles.opacity
          }`}
          onClick={this.closeSidebar}
        >
          <Navbar toggleCollapse={this.toggleCollapse} />
          <main className={styles.main}>
            {project && project.loading && (
              <FullLoading
                showMessage={Boolean(
                  location?.pathname === '/book/date'
                )}
              />
            )}
            {/* <FullLoading /> */}
            {project && project.data && <Checkout {...project} />}
            {this.createRoutes(routes)}
          </main>
          <BottomBar />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: { project: any }) => {
  return {
    project: state.project
  }
}
export default connect(mapStateToProps)(Layout)
